import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from '../layouts/loader/Loadable';
// import SessionManagements from '../VMS/Component/Common/Utils/SessionManagements';
// import  {socketFunction}  from '../App';
/****Layouts*****/

const FullLayout = Loadable(lazy(() => import('../layouts/FullLayout')));
const VendorFullLayout = Loadable(lazy(() => import('../VMS/Component/Common/FullLayoutPages/VendorFullLayout')))
const BlankLayout = Loadable(lazy(() => import('../layouts/BlankLayout')));
/***** Pages ****/

const Dashboard1 = Loadable(lazy(() => import('../views/dashboards/Dashboard1')));
const Dashboard2 = Loadable(lazy(() => import('../views/dashboards/Dashboard2')));
const Dashboard3 = Loadable(lazy(() => import('../views/dashboards/Dashboard3')));
const Dashboard4 = Loadable(lazy(() => import('../views/dashboards/Dashboard4')));
const About = Loadable(lazy(() => import('../views/About')));

/***** Apps ****/
const Notes = Loadable(lazy(() => import('../views/apps/notes/Notes')));
const Chat = Loadable(lazy(() => import('../views/apps/chat/Chat')));
const Contacts = Loadable(lazy(() => import('../views/apps/contacts/Contacts')));
const Calendar = Loadable(lazy(() => import('../views/apps/calendar/CalendarApp')));
const Email = Loadable(lazy(() => import('../views/apps/email/Email')));
const Shop = Loadable(lazy(() => import('../views/apps/ecommerce/Shop')));
const ShopDetail = Loadable(lazy(() => import('../views/apps/ecommerce/ShopDetail')));
const Treeview = Loadable(lazy(() => import('../views/apps/treeview/TreeView')));
const TicketList = Loadable(lazy(() => import('../views/apps/ticket/TicketList')));
const TicketDetail = Loadable(lazy(() => import('../views/apps/ticket/TicketDetail')));

/***** Ui Elements ****/
const Alerts = Loadable(lazy(() => import('../views/ui/Alerts')));
const Badges = Loadable(lazy(() => import('../views/ui/Badges')));
const Buttons = Loadable(lazy(() => import('../views/ui/Buttons')));
const Cards = Loadable(lazy(() => import('../views/ui/Cards')));
const Grid = Loadable(lazy(() => import('../views/ui/Grid')));
const Tables = Loadable(lazy(() => import('../views/ui/Tables')));
const Forms = Loadable(lazy(() => import('../views/ui/Forms')));
const Breadcrumbs = Loadable(lazy(() => import('../views/ui/Breadcrumbs')));
const Dropdowns = Loadable(lazy(() => import('../views/ui/DropDown')));
const BtnGroup = Loadable(lazy(() => import('../views/ui/BtnGroup')));
const Collapse = Loadable(lazy(() => import('../views/ui/Collapse')));
const ListGroup = Loadable(lazy(() => import('../views/ui/ListGroup')));
const Modal = Loadable(lazy(() => import('../views/ui/Modal')));
const Navbar = Loadable(lazy(() => import('../views/ui/Navbar')));
const Nav = Loadable(lazy(() => import('../views/ui/Nav')));
const Pagination = Loadable(lazy(() => import('../views/ui/Pagination')));
const Popover = Loadable(lazy(() => import('../views/ui/Popover')));
const Progress = Loadable(lazy(() => import('../views/ui/Progress')));
const Spinner = Loadable(lazy(() => import('../views/ui/Spinner')));
const Tabs = Loadable(lazy(() => import('../views/ui/Tabs')));
const Toasts = Loadable(lazy(() => import('../views/ui/Toasts')));
const Tooltip = Loadable(lazy(() => import('../views/ui/Tooltip')));

/***** Form Layout Pages ****/
const FormBasic = Loadable(lazy(() => import('../views/form-layouts/FormBasic')));
const FormGrid = Loadable(lazy(() => import('../views/form-layouts/FormGrid')));
const FormGroup = Loadable(lazy(() => import('../views/form-layouts/FormGroup')));
const FormInput = Loadable(lazy(() => import('../views/form-layouts/FormInput')));
const FormEditor = Loadable(lazy(() => import('../views/form-editor/FormEditor')));

/***** Form Pickers Pages ****/
const Datepicker = Loadable(lazy(() => import('../views/form-pickers/DateTimePicker')));
const TagSelect = Loadable(lazy(() => import('../views/form-pickers/TagSelect')));

/***** Form Validation Pages ****/
const FormValidate = Loadable(lazy(() => import('../views/form-validation/FormValidation')));
const FormSteps = Loadable(lazy(() => import('../views/form-steps/Steps')));

/***** Table Pages ****/
const Basictable = Loadable(lazy(() => import('../views/tables/TableBasic')));
const CustomReactTable = Loadable(lazy(() => import('../views/tables/CustomReactTable')));
const ReactBootstrapTable = Loadable(lazy(() => import('../views/tables/ReactBootstrapTable')));

/***** Chart Pages ****/
const ApexCharts = Loadable(lazy(() => import('../views/charts/ApexCharts')));
const ChartJs = Loadable(lazy(() => import('../views/charts/ChartJs')));

/***** Sample Pages ****/
const StarterKit = Loadable(lazy(() => import('../views/sample-pages/StarterKit')));
const Profile = Loadable(lazy(() => import('../views/sample-pages/Profile')));
const Gallery = Loadable(lazy(() => import('../views/sample-pages/Gallery')));
const SearchResult = Loadable(lazy(() => import('../views/sample-pages/SearchResult')));
const HelperClass = Loadable(lazy(() => import('../views/sample-pages/HelperClass')));

/***** Icon Pages ****/
const Bootstrap = Loadable(lazy(() => import('../views/icons/Bootstrap')));
const Feather = Loadable(lazy(() => import('../views/icons/Feather')));

/***** Map Pages ****/
const CustomVectorMap = Loadable(lazy(() => import('../views/maps/CustomVectorMap')));

/***** Widget Pages ****/
const Widget = Loadable(lazy(() => import('../views/widget/Widget')));

/***** CASL Access Control ****/
const CASL = Loadable(lazy(() => import('../views/apps/accessControlCASL/AccessControl')));

/***** Auth Pages ****/
const Error = Loadable(lazy(() => import('../views/auth/Error')));
const RegisterFormik = Loadable(lazy(() => import('../views/auth/RegisterFormik')));
const LoginFormik = Loadable(lazy(() => import('../views/auth/LoginFormik')));
const Maintanance = Loadable(lazy(() => import('../views/auth/Maintanance')));
const LockScreen = Loadable(lazy(() => import('../views/auth/LockScreen')));
const RecoverPassword = Loadable(lazy(() => import('../views/auth/RecoverPassword')));
// const AdminRegistration = Loadable(lazy(() =>import('../VMS/Component/Index/Register/Admin/Adminregistration')))
const VmsAdmin = Loadable(lazy(() => import('../VMS/Component/Index/Register/Admin/VmsAdmin')))
const VmsLogin = Loadable(lazy(() => import('../VMS/Component/Index/SignIn/VmsSignIn')))
// const VendorRegistration = Loadable(lazy(() => import('../VMS/Component/Index/Register/Vendor/VmsVendor')))
const Vmsvendorreg = Loadable(lazy(() => import('../VMS/Component/Index/Register/Vendor/VmsVendorReg')))
// const AdminDashBoardimport = Loadable(lazy(() => import('../VMS/Component/LandingPage/AdminDashBoard')))
const VendorDashBoard = Loadable(lazy(() => import('../VMS/Component/LandingPage/DashBoard/VendorDashBoard')))
// const FullLayouts = Loadable(lazy(() => import('../VMS/Component/Common/FullLayoutPages/FullLayouts')))
// const Header = Loadable(lazy(() =>import('../layouts/header/Header')))
// const SideBar = Loadable(lazy(() => import('../layouts/sidebars/vertical/Sidebar')))
const PendingList = Loadable(lazy(() => import('../VMS/Component/LandingPage/Admin/PendingList')))
const ApprovedList = Loadable(lazy(() => import('../VMS/Component/LandingPage/Admin/ApprovedList')))
const PO = Loadable(lazy(() => import('../VMS/Component/LandingPage/Admin/PO')))
const RFQ = Loadable(lazy(() => import('../VMS/Component/LandingPage/Admin/RFQ')))
const AdminDashBoard = Loadable(lazy(() => import('../VMS/Component/LandingPage/DashBoard/AdminDashBoard')))
const CompletedList = Loadable(lazy(() => import('../VMS/Component/LandingPage/Admin/CompletedList')))
const EditFormtab = Loadable(lazy(() => import('../VMS/Component/LandingPage/Admin/EditFormTab')))
const VendorCompletedList = Loadable(lazy(() => import('../VMS/Component/LandingPage/Admin/VendorCompletedList')))
const VendorReadyToExport = Loadable(lazy(() => import('../VMS/Component/LandingPage/Admin/VendorReadyToExport')))
const VendorDraftList = Loadable(lazy(() => import('../VMS/Component/LandingPage/Admin/VendorDraftList')))
const VendorPO = Loadable(lazy(() => import('../VMS/Component/LandingPage/Vendor/VendorPO')))
const VendorRFQ = Loadable(lazy(() => import('../VMS/Component/LandingPage/Vendor/VendorRFQ')))
const VendorRFQList = Loadable(lazy(() => import('../VMS/Component/LandingPage/Vendor/VendorRFQList')))
const VendorPOItemList = Loadable(lazy(() => import('../VMS/Component/LandingPage/Vendor/VendorPOItemList')))
const VendorShipmentdetailsForm = Loadable(lazy(() => import('../VMS/Component/LandingPage/Vendor/VendorShipmentdetailsForm')))
const VendorProfilePage = Loadable(lazy(() => import('../VMS/Component/LandingPage/Vendor/VendorProfilePage')))
const SubmittedRFQ = Loadable(lazy(() => import('../VMS/Component/LandingPage/Vendor/SubmittedRFQ')))
const ReOpenedRFQ = Loadable(lazy(() => import('../VMS/Component/LandingPage/Vendor/ReOpenedRFQ')))
const ClosedRfq = Loadable(lazy(() => import('../VMS/Component/LandingPage/Vendor/ClosedRfq')))
const ReceivedRFQ = Loadable(lazy(() => import('../VMS/Component/LandingPage/Admin/RFQ Maintenance/ReceivedRFQ')))
const ResendRFQ = Loadable(lazy(() => import('../VMS/Component/LandingPage/Admin/RFQ Maintenance/ResendRFQ')))
const ApprovedRFQ = Loadable(lazy(() => import('../VMS/Component/LandingPage/Admin/RFQ Maintenance/ApprovedRFQ')))
const RejectedRFQ = Loadable(lazy(() => import('../VMS/Component/LandingPage/Admin/RFQ Maintenance/RejectedRFQ')))
const RFQEditScreenAdmin = Loadable(lazy(() => import('../VMS/Component/LandingPage/Admin/RFQ Maintenance/Utils/RFQEditScreenAdmin')))
const PrivateRoute = Loadable(lazy(() => import('../VMS/Component/LandingPage/ProtectedRoute/PrivateRoute')))
const PrivateRouteVendor = Loadable(lazy(() => import('../VMS/Component/LandingPage/ProtectedRoute/PrivateRouteVendor')))
const RejectedRFQVendor = Loadable(lazy(() => import('../VMS/Component/LandingPage/Vendor/RejectedRFQ')))
const POOpenedLineItems = Loadable(lazy(() => import('../VMS/Component/LandingPage/Vendor/POOpenedLineItems')))
const POAcceptedLineItems = Loadable(lazy(() => import('../VMS/Component/LandingPage/Vendor/POAcceptedLineItems')))
const Acknowledgement = Loadable(lazy(() => import('../VMS/Component/LandingPage/Admin/PO/Acknowledgement')))
const OpenedLineItems = Loadable(lazy(() => import('../VMS/Component/LandingPage/Admin/PO/OpenedLineItems')))
const AcceptedLineItems = Loadable(lazy(() => import('../VMS/Component/LandingPage/Admin/PO/AcceptedLineItems')))
const NotificationPage = Loadable(lazy(() => import('../VMS/Component/LandingPage/Notification/NotificationPage')))
const NotificationVendor = Loadable(lazy(() => import('../VMS/Component/LandingPage/Notification/NotificationVendor')))
const PriceCompare  = Loadable(lazy(() => import('../VMS/Component/LandingPage/Admin/RFQ Maintenance/CompareRFQPrices')))


/*****Routes******/

const ThemeRoutes = [
  {
    path: '/',
    children: [
      { path: '/', name: 'Home', element: <Navigate to="/Vms-login" /> },
      { path: '/Vms-admin', element: <VmsAdmin /> },
      { path: '/Vms-login', element: <VmsLogin /> },
      { path: '/Vms-vendor-reg', element: <Vmsvendorreg /> },
    ]

  },
  {
    path: '/',
    element: <VendorFullLayout />,
    children: [
      { path: '/', name: 'Home', element: <Navigate to="/adminDashBoard" /> },
      { path: '/adminDashBoard', element: <PrivateRoute><AdminDashBoard /></PrivateRoute> },
      { path: '/pending-list', element: <PrivateRoute><PendingList /></PrivateRoute> },
      { path: '/approved-list', element: <PrivateRoute><ApprovedList /></PrivateRoute> },
      { path: '/completed-list', element: <PrivateRoute><CompletedList /></PrivateRoute> },
      { path: '/Profile-of-vendor', element: <PrivateRoute><VendorProfilePage /></PrivateRoute> },

      { path: '/po', element: <PrivateRoute><PO /></PrivateRoute> },
      { path: '/rfq', element: <PrivateRoute><RFQ /></PrivateRoute> },
      { path: '/editFormTab', element: <PrivateRoute><EditFormtab /></PrivateRoute> },
      { path: '/completedList', element: <PrivateRoute><VendorCompletedList /></PrivateRoute> },
      { path: '/export-vendor-records', element: <PrivateRoute><VendorReadyToExport /></PrivateRoute> },
      { path: '/vendor-draft-list', element: <PrivateRoute><VendorDraftList /></PrivateRoute> },
      { path: '/Rfq-received', element: <PrivateRoute><ReceivedRFQ /></PrivateRoute> },
      { path: '/Rfq-received/comparePrices', element: <PrivateRoute><PriceCompare /></PrivateRoute> },
      { path: '/Rfq-reopened', element: <PrivateRoute><ResendRFQ /></PrivateRoute> },
      { path: '/Rfq-approved', element: <PrivateRoute><ApprovedRFQ /></PrivateRoute> },
      { path: '/Rfq-rejected', element: <PrivateRoute> <RejectedRFQ /></PrivateRoute> },
      { path: '/Rfq-EditForm', element: <PrivateRoute><RFQEditScreenAdmin /></PrivateRoute> },
      { path: '/Rfq-POAcknowledge', element: <PrivateRoute><Acknowledgement /></PrivateRoute> },
      { path: '/Rfq-OpenedLineItems', element: <PrivateRoute><OpenedLineItems /></PrivateRoute> },
      { path: '/Rfq-AcceptedLineItems', element: <PrivateRoute><AcceptedLineItems /></PrivateRoute> },
      { path: '/notifications-Admin', element: <PrivateRoute><NotificationPage data="Admin" /></PrivateRoute> },
      ///vendor
      { path: '/', name: 'Home', element: <Navigate to='/vendordashboard' /> },
      { path: '/vendordashboard', element: <PrivateRouteVendor><VendorDashBoard /></PrivateRouteVendor> },
      { path: '/Vms-vendorrfqlist', element: <PrivateRouteVendor><VendorRFQList /></PrivateRouteVendor> },
      { path: '/vendor-Profile', element: <PrivateRouteVendor><VendorProfilePage /></PrivateRouteVendor> },
      { path: '/Vms-vendorItemList', element: <PrivateRouteVendor><VendorPOItemList /></PrivateRouteVendor> },
      { path: '/Vms-VendorShipmentdetails', element: <PrivateRouteVendor><VendorShipmentdetailsForm /></PrivateRouteVendor> },
      { path: '/Vms-VendorRFQ', element: <PrivateRouteVendor><VendorRFQ /></PrivateRouteVendor> },
      { path: '/Vms-VendorPO', element: <PrivateRouteVendor><VendorPO /></PrivateRouteVendor> },
      { path: '/Vms-SubmittedRFQ', element: <PrivateRouteVendor><SubmittedRFQ /></PrivateRouteVendor> },
      { path: '/Vms-reOpenedRfq', element: <PrivateRouteVendor><ReOpenedRFQ /></PrivateRouteVendor> },
      { path: '/Vms-closedRfq', element: <PrivateRouteVendor> <ClosedRfq /></PrivateRouteVendor> },
      { path: '/NotificationVendor', element: <PrivateRouteVendor><NotificationVendor /></PrivateRouteVendor> },
      { path: '/Vms-RejectedRfq', element: <PrivateRouteVendor> <RejectedRFQVendor /></PrivateRouteVendor> },
      { path: '/Vms-OpenedPOLineItem', element: <PrivateRouteVendor> <POOpenedLineItems /></PrivateRouteVendor> },
      { path: '/Vms-AcceptedPOLineItem', element: <PrivateRouteVendor> <POAcceptedLineItems /></PrivateRouteVendor> },
    ]

  },
  // {
  //   path: '/',
  //   element: <VendorFullLayout />,
  //   children: [
      
      
  //   ]

  // },
  {
    path: '/',
    element: <FullLayout />,
    children: [
      { path: '/', name: 'Home', element: <Navigate to="/dashboards/dashboard1" /> },
      { path: '/dashboards/dashboard1', name: 'Dashboard 1', exact: true, element: <Dashboard1 /> },
      { path: '/dashboards/dashboard2', name: 'Dashboard 2', exact: true, element: <Dashboard2 /> },
      { path: '/dashboards/dashboard3', name: 'Dashboard 3', exact: true, element: <Dashboard3 /> },
      { path: '/dashboards/dashboard4', name: 'Dashboard 4', exact: true, element: <Dashboard4 /> },
      { path: '/about', name: 'about', exact: true, element: <About /> },
      { path: '/apps/notes', name: 'notes', exact: true, element: <Notes /> },
      { path: '/apps/chat', name: 'chat', exact: true, element: <Chat /> },
      { path: '/apps/contacts', name: 'contacts', exact: true, element: <Contacts /> },
      { path: '/apps/calendar', name: 'calendar', exact: true, element: <Calendar /> },
      { path: '/apps/email', name: 'email', exact: true, element: <Email /> },
      { path: '/ecom/shop', name: 'email', exact: true, element: <Shop /> },
      { path: '/ecom/shopdetail', name: 'email', exact: true, element: <ShopDetail /> },
      { path: '/tickt/ticket-list', name: 'ticket list', exact: true, element: <TicketList /> },
      {
        path: '/tickt/ticket-detail',
        name: 'ticket detail',
        exact: true,
        element: <TicketDetail />,
      },
      { path: '/apps/treeview', name: 'email', exact: true, element: <Treeview /> },
      { path: '/ui/alerts', name: 'alerts', exact: true, element: <Alerts /> },
      { path: '/ui/badges', name: 'badges', exact: true, element: <Badges /> },
      { path: '/ui/buttons', name: 'buttons', exact: true, element: <Buttons /> },
      { path: '/ui/cards', name: 'cards', exact: true, element: <Cards /> },
      { path: '/ui/grid', name: 'grid', exact: true, element: <Grid /> },
      { path: '/ui/table', name: 'table', exact: true, element: <Tables /> },
      { path: '/ui/forms', name: 'forms', exact: true, element: <Forms /> },
      { path: '/ui/breadcrumbs', name: 'breadcrumbs', exact: true, element: <Breadcrumbs /> },
      { path: '/ui/dropdown', name: 'dropdown', exact: true, element: <Dropdowns /> },
      { path: '/ui/button-group', name: 'button group', exact: true, element: <BtnGroup /> },
      { path: '/ui/collapse', name: 'collapse', exact: true, element: <Collapse /> },
      { path: '/ui/list-group', name: 'list-group', exact: true, element: <ListGroup /> },
      { path: '/ui/modal', name: 'modal', exact: true, element: <Modal /> },
      { path: '/ui/navbar', name: 'navbar', exact: true, element: <Navbar /> },
      { path: '/ui/nav', name: 'nav', exact: true, element: <Nav /> },
      { path: '/ui/pagination', name: 'pagination', exact: true, element: <Pagination /> },
      { path: '/ui/popover', name: 'popover', exact: true, element: <Popover /> },
      { path: '/ui/progress', name: 'progress', exact: true, element: <Progress /> },
      { path: '/ui/spinner', name: 'spinner', exact: true, element: <Spinner /> },
      { path: '/ui/tabs', name: 'tabs', exact: true, element: <Tabs /> },
      { path: '/ui/toasts', name: 'toasts', exact: true, element: <Toasts /> },
      { path: '/ui/tooltip', name: 'tooltip', exact: true, element: <Tooltip /> },
      { path: '/form-layout/form-basic', name: 'form-basic', exact: true, element: <FormBasic /> },
      { path: '/form-layout/form-grid', name: 'form-grid', exact: true, element: <FormGrid /> },
      { path: '/form-layout/form-group', name: 'form-group', exact: true, element: <FormGroup /> },
      { path: '/form-layout/form-input', name: 'form-input', exact: true, element: <FormInput /> },
      {
        path: '/form-pickers/datepicker',
        name: 'datepicker',
        exact: true,
        element: <Datepicker />,
      },
      { path: '/form-pickers/tag-select', name: 'tag-select', exact: true, element: <TagSelect /> },
      { path: '/form-validation', name: 'form-validation', exact: true, element: <FormValidate /> },
      { path: '/form-steps', name: 'form-steps', exact: true, element: <FormSteps /> },
      { path: '/form-editor', name: 'form-editor', exact: true, element: <FormEditor /> },
      { path: '/tables/basic-table', name: 'basic-table', exact: true, element: <Basictable /> },
      {
        path: '/tables/react-table',
        name: 'react-table',
        exact: true,
        element: <CustomReactTable />,
      },
      {
        path: '/tables/data-table',
        name: 'data-table',
        exact: true,
        element: <ReactBootstrapTable />,
      },
      { path: '/charts/apex', name: 'apex', exact: true, element: <ApexCharts /> },
      { path: '/charts/chartjs', name: 'chartjs', exact: true, element: <ChartJs /> },
      { path: '/sample-pages/profile', name: 'profile', exact: true, element: <Profile /> },
      {
        path: '/sample-pages/helper-class',
        name: 'helper-class',
        exact: true,
        element: <HelperClass />,
      },
      {
        path: '/sample-pages/starterkit',
        name: 'starterkit',
        exact: true,
        element: <StarterKit />,
      },
      { path: '/sample-pages/gallery', name: 'gallery', exact: true, element: <Gallery /> },
      {
        path: '/sample-pages/search-result',
        name: 'search-result',
        exact: true,
        element: <SearchResult />,
      },
      { path: '/icons/bootstrap', name: 'bootstrap', exact: true, element: <Bootstrap /> },
      { path: '/icons/feather', name: 'feather', exact: true, element: <Feather /> },
      { path: '/map/vector', name: 'vector', exact: true, element: <CustomVectorMap /> },
      { path: '/widget', name: 'widget', exact: true, element: <Widget /> },
      { path: '/casl', name: 'casl', exact: true, element: <CASL /> },
      { path: '*', element: <Navigate to="/auth/404" /> },
    ],
  },
  {
    path: '/auth',
    element: <BlankLayout />,
    children: [
      { path: '404', element: <Error /> },
      { path: '*', element: <Navigate to="/auth/404" /> },
      { path: 'registerformik', element: <RegisterFormik /> },
      { path: 'loginformik', element: <LoginFormik /> },
      { path: 'maintanance', element: <Maintanance /> },
      { path: 'lockscreen', element: <LockScreen /> },
      { path: 'recoverpwd', element: <RecoverPassword /> },
    ],
  },
];

export default ThemeRoutes;
